import gettext from '@sdk/lang/gettext';

import { isMessagePost } from '@web/conversations/utils/guards';
import {
  useSearchListScroll,
  useConversationSearchList,
} from '@web/conversations/ConversationSearch/ConversationSearchList/conversationSearchList.hooks';
import { LoadingTextIndicator as PageLoader } from '@web/components/LoadingTextIndicator/LoadingTextIndicator';
import { ConversationSearchItem } from '@web/conversations/ConversationSearch/ConversationSearchItem/ConversationSearchItem';
import { LoaderWrapper } from '@web/conversations/Conversation/ConversationInfiniteList/conversationInfiniteList.styles';
import {
  ItemsList,
  ItemsListWraper,
  EmptySearchWrapper,
} from '@web/conversations/ConversationSearch/ConversationSearchList/conversationSearchList.styles';
import { EmptySearchResults } from '@web/components/EmptySearchResults/EmptySearchResults';
import { ConversationSearchSkeleton } from '@web/conversations/ConversationSearch/ConversationSearchSkeleton/ConversationSearchSkeleton';

export const ConversationSearchList = () => {
  const {
    firstItemId,
    infiniteQueryMetaData,
    isLoadingResults,
    loadOlder,
    results,
    setLoadMoreNode,
  } = useConversationSearchList();
  const { isLoading, hasPreviousPage, isFetchingPreviousPage } = infiniteQueryMetaData;
  const { listFooterRef, setFirstItemRef } = useSearchListScroll(results, isLoading);

  if (!results?.length && !isLoadingResults) {
    return (
      <EmptySearchWrapper>
        <EmptySearchResults mTop={160} />
      </EmptySearchWrapper>
    );
  }

  return (
    <ItemsListWraper>
      <ItemsList>
        {hasPreviousPage && (
          <LoaderWrapper ref={setLoadMoreNode}>
            <PageLoader
              isPaused={!isLoadingResults}
              label={isFetchingPreviousPage ? undefined : gettext('Load more results')}
              onClick={loadOlder}
            />
          </LoaderWrapper>
        )}

        {isLoadingResults && <ConversationSearchSkeleton />}

        {results?.map(
          (message, index) =>
            isMessagePost(message) && (
              <div key={index}>
                {firstItemId === message.id && <div ref={setFirstItemRef}></div>}
                <ConversationSearchItem message={message} />
              </div>
            )
        )}

        <footer ref={listFooterRef}></footer>
      </ItemsList>
    </ItemsListWraper>
  );
};
